<template>
  <button
    type="button"
    @click="goBack"
    class="volver-button inline-flex items-center gap-2 text-white text-lg"
    :aria-label="text"
  >
    <img
      :src="volverIcon"
      alt=""
      class="volver-button__icon h-10 w-10 shrink-0"
    />
    {{ text }}
  </button>
</template>

<script setup>
import { useRouter } from "vue-router";
import volverIcon from "@/assets/images/volver.svg";

const props = defineProps({
  to: {
    type: String,
    default: "/",
  },
  text: {
    type: String,
    default: "Volver",
  },
});

const router = useRouter();

function goBack() {
  // Vue Router guarda y restaura el scroll al navegar por el historial.
  // Si se abrió está página directamente, usamos la ruta indicada cómo respaldo.
  if (window.history.state?.back) {
    router.back();
    return;
  }
  router.push(props.to);
}
</script>

<style scoped>
.volver-button {
  text-decoration: none;
  transition: transform 240ms cubic-bezier(0.22, 1, 0.36, 1), color 200ms ease,
    filter 200ms ease;
}

.volver-button__icon {
  transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1);
}

.volver-button:hover {
  transform: translateX(-3px);
  filter: brightness(1.15);
}

.volver-button:hover .volver-button__icon {
  transform: translateX(-5px) rotate(-5deg);
}

.volver-button:active {
  transform: translateX(-1px) scale(0.96);
}

.volver-button:focus-visible {
  outline: 2px solid #a52121;
  outline-offset: 3px;
  border-radius: 9999px;
}

@media (prefers-reduced-motion: reduce) {
  .volver-button,
  .volver-button__icon {
    transition: none;
  }

  .volver-button:hover,
  .volver-button:hover .volver-button__icon {
    transform: none;
  }
}
</style>
